import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface GetClientInventoryCrewListPayload {
  removalLeadId: string | number;
  page?: number;
  limit?: number;
  orderBy?: string;
  orderIn?: string;
}

export interface SendInventoryCrewLinkPayload {
  crewId: string | null;
  email: string;
  contractId: string | number;
}

const initialState = {
  clientInventoryCrewList: null,
  clientInventoryCrewDetails: null,
  crewSurveyItems: null,
  isCrewSurveyItemsLoading: false,
  isInventoryCrewDetailsUpdated: false,
  isInventoryNoteUpdated: false,
  crewInventoryPhotoUpload: {
    fileName: "",
    key: "",
    url: "",
    isUploading: false,
    hasError: false,
  },
  isDeleteInventoryResponse: false,
  isSendInventoryCrewSendLinkResponse: false,
  isTokenVerifyInventoryCrewLinkResponse: false,
  isResetInventoryCrewLinkResponse: false,
  isSendInventoryCrewSendOtpResponse: false,
  verifyInventoryCrewLinkResponse: null,
  isCrewTokenInValid: false,
  isCrewSendOtpSuccess: false,
  isVerifyCrewOtpSuccess: false,
};

const inventoryCrewSlice = createSlice({
  name: "inventoryCrew",
  initialState,

  reducers: {
    getClientInventoryCrewListAction: (
      state,
      { payload }: PayloadAction<GetClientInventoryCrewListPayload>,
    ) => {},
    setClientInventoryCrewListAction: (state, { payload }) => {
      const { pagination = { currentPage: 1 }, crews = [] } = payload;
      state.clientInventoryCrewList = crews;
    },

    getInventoryCrewDetailsAction: (state, { payload }) => {},
    getCrewSurveyItemsAction: (state, { payload }) => {
      state.isCrewSurveyItemsLoading = true;
    },
    setCrewSurveyItemsAction: (state, { payload }) => {
      state.crewSurveyItems = payload;
      state.isCrewSurveyItemsLoading = false;
    },
    setInventoryCrewDetailsAction: (state, { payload }) => {
      state.clientInventoryCrewDetails = payload;
    },

    updateInventoryCrewDetailsAction: (state, { payload }) => {},
    uploadCrewInventoryPhotoAction: (state, { payload }) => {
      state.crewInventoryPhotoUpload = {
        fileName: payload.file.name,
        key: "",
        url: "",
        isUploading: true,
        hasError: false,
      };
    },
    setCrewInventoryPhotoUploadAction: (state, { payload }) => {
      state.crewInventoryPhotoUpload = payload;
    },
    setUpdateInventoryCrewDetailsAction: (state, { payload }) => {
      state.isInventoryCrewDetailsUpdated = payload;
    },
    setInventoryNoteUpdatedAction: (state, { payload }) => {
      state.isInventoryNoteUpdated = payload;
    },

    deleteInventoryAction: (state, { payload }) => {},
    setDeleteInventoryResponseAction: (state, { payload }) => {
      state.isDeleteInventoryResponse = payload;
      if (payload) {
        state.clientInventoryCrewDetails = null;
      }
    },

    sendInventoryCrewSendLinkAction: (
      state,
      { payload }: PayloadAction<SendInventoryCrewLinkPayload>,
    ) => {},
    setSendInventoryCrewSendLinkAction: (state, { payload }) => {
      state.isSendInventoryCrewSendLinkResponse = payload;
    },

    tokenVerifyInventoryCrewLinkAction: (state, { payload }) => {},
    setTokenVerifyInventoryCrewLinkAction: (state, { payload }) => {
      state.isTokenVerifyInventoryCrewLinkResponse = payload;
    },

    sendInventoryCrewSendOtpAction: (state, { payload }) => {},
    setSendInventoryCrewSendOtpAction: (state, { payload }) => {
      state.isSendInventoryCrewSendOtpResponse = payload;
    },

    urlVerifyInventoryCrewLinkAction: (state, { payload }) => {},
    setUrlVerifyInventoryCrewLinkAction: (state, { payload }) => {
      state.verifyInventoryCrewLinkResponse = payload;
    },

    setCrewTokenInValidAction: (state, { payload }) => {
      state.isCrewTokenInValid = payload;
    },

    sendCrewOtpAction: (state, { payload }) => {},
    setSendCrewOtpAction: (state, { payload }) => {
      state.isCrewSendOtpSuccess = payload;
    },

    verifyCrewOtpAction: (state, { payload }) => {},
    setVerifyCrewOtpAction: (state, { payload }) => {
      state.isVerifyCrewOtpSuccess = payload;
    },
  },
});

export const {
  getClientInventoryCrewListAction,
  setClientInventoryCrewListAction,
  getInventoryCrewDetailsAction,
  getCrewSurveyItemsAction,
  setCrewSurveyItemsAction,
  setInventoryCrewDetailsAction,
  updateInventoryCrewDetailsAction,
  uploadCrewInventoryPhotoAction,
  setCrewInventoryPhotoUploadAction,
  setUpdateInventoryCrewDetailsAction,
  setInventoryNoteUpdatedAction,
  deleteInventoryAction,
  setDeleteInventoryResponseAction,
  sendInventoryCrewSendLinkAction,
  setSendInventoryCrewSendLinkAction,
  tokenVerifyInventoryCrewLinkAction,
  setTokenVerifyInventoryCrewLinkAction,
  urlVerifyInventoryCrewLinkAction,
  setUrlVerifyInventoryCrewLinkAction,
  setCrewTokenInValidAction,
  sendCrewOtpAction,
  setSendCrewOtpAction,
  verifyCrewOtpAction,
  setVerifyCrewOtpAction,
} = inventoryCrewSlice.actions;

export default inventoryCrewSlice.reducer;
